import {Request} from "../models/Request";
import {RequestWithUnfinishedDispositionsTemplateData} from "./RequestWithUnfinishedDispositionsTemplateData";
import {RequestWithUnfinishedDispositionsImportTemplate} from "./RequestWithUnfinishedDispositionsImportTemplate";
import {cloneDeep} from "lodash";

export const getRequestWithUnfinishedDispositionsTemplate = (
    mercantileRequestData: Request[],
    repromaterialRequestData: Request[],
    place: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    return RequestWithUnfinishedDispositionsImportTemplate(
        prepareData(
            mercantileRequestData,
            repromaterialRequestData,
            place,
            dateFrom,
            dateTo
        )
    );
};

const prepareData = (
    mercantileRequestData: Request[],
    repromaterialRequestData: Request[],
    place: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    const templateData: RequestWithUnfinishedDispositionsTemplateData = {
        place: place,
        mercantileRequestData: cloneDeep(mercantileRequestData),
        repromaterialRequestData: cloneDeep(repromaterialRequestData),
        dateFrom: dateFrom,
        dateTo: dateTo
    };

    return templateData;
};